import { postRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';
import createUrlBuilder from 'utilities/url.builder.utils';

export const sendFeedback = async (params: any) => {
  const data = {
    label: params.label,
    subject: params.subject,
    body: params.body
  };
  const urlBuilder = createUrlBuilder(`/feedback`).toString();

  return await postRequest(LocateService, urlBuilder, data);
};
